import React, { useContext, useEffect } from "react";
import {Outlet} from 'react-router-dom';
import { useLocation,useNavigate } from 'react-router-dom';
import LayoutMain from './LayoutMain/LayoutMain';
import DashboardMain from './DashboardMain/DashboardMain';
import AppContext from '../../store/AppContext';

function Dashboard(props) {
  let location = useLocation();
  let path_check = location.pathname;
  const authctx = useContext(AppContext);
  const navigate = useNavigate();
  useEffect(()=>{
    if(authctx.username == "" || authctx.username == null){
      navigate("/login");
    }
  },[authctx])



    if(path_check.indexOf("dashboard") != -1){
      return (
        <>
        <DashboardMain>
          <Outlet />
          </DashboardMain> 
        </> 
      );
    }else{
      return (
        <>
        <LayoutMain>
          <Outlet />
          </LayoutMain> 
        </> 
      );
    }
  }
  export default Dashboard;